import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'
import { TaskModel, taskUrl } from '@store/slices/task.slice'

export const updateRunningTasks = createAsyncThunk(
  'task/updateRunning',
  async (ids: EntityId[]) => {
    if (ids.length == 0) return [] as TaskModel[]
    try {
      const params: any = { id__in: ids.join(','), finished: true }
      const response = await api.get(`${taskUrl}`, { params })
      return response.data as TaskModel[]
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se aktualizovat bežící procesy'}`
        )
      } else {
        toast.error('Nepodařilo se aktualizovat bežící procesy')
      }
      throw axiosError
    }
  }
)

export const fetchAllTasks = createAsyncThunk(
  'task/fetchAllTasks',
  async (ids?: EntityId[]) => {
    try {
      const params: any = {}
      if (!!ids && ids.length > 0) params.id__in = ids.join(',')
      const response = await api.get(`${taskUrl}`, { params })
      return response.data as TaskModel[]
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se stáhnout procesy'}`
        )
      } else {
        toast.error('Nepodařilo se stahnout procesy')
      }
      throw axiosError
    }
  }
)

export const fetchTaskById = createAsyncThunk(
  'task/fetchTaskById',
  async (taskId: EntityId) => {
    try {
      const response = await api.get(`${taskUrl}${taskId.toString()}/`)
      return response.data as TaskModel
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se stáhnout proces: ' + taskId}`
        )
      } else {
        toast.error('Nepodařilo se stáhnout proces: ' + taskId)
      }
      throw axiosError
    }
  }
)
